module.exports = __webpack_public_path__ + "static/8-c7d47bda48ddb714a020bb5acc32742e.png";